export default "__VITE_ASSET__Dw6DQ7Yb__"